import FilterStore from './FilterStore'

const coll = {}

function createFilterStore(name, props) {
  coll[name] = new FilterStore(props)
  return coll[name]
}
function getFilterStore(name) {
  return coll[name]
}
function clearFilterStore(name) {
  delete coll[name]
}
export { createFilterStore, getFilterStore, clearFilterStore }
